<app-header></app-header>
<div class="our-worlds">
    <p class="title-our-world">Feria de Negocios</p>
    <div class="line-our-world"></div>

    <!-- Caracteristicas -->
    <div class="our-worlds-container">
        <div class="side-right-ferias">
            <p class="title-side-right-ferias">CARACTERISTICAS</p><br>
            <p class="description-side-right-ferias">
                <b>¡Somos la solución integral para el diseño y desarrollo exitoso de su feria de negocios</b>
            </p><br><br>
            <div class="row">

                <div class="col-12 col-lg-4 padding-ten-right lg-padding-five-right md-padding-15px-right md-margin-five-bottom wow fadeIn border-right border-color-extra-medium-gray text-align-center"
                    style="visibility: visible; animation-name: fadeIn;">
                    <p class="subtitle-caracteristica">Antes del evento</p>
                    <div class="line-our-world2"></div> <br>
                    <div class="icon-box d-table w-100 mx-auto mx-lg-0 last-paragraph-no-margin">
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Configuración de la estructura dela feria:
                                    mediante un panel de administrador, de manera intuitiva se definen los stand para
                                    ser asignados a los expositores, definir los permisos de acceso y gestionar la
                                    agenda de ejecucción. </div>
                                <br><br>
                            </div>
                        </div>
                    </div>
                    <div class="icon-box d-table w-100 mx-auto mx-lg-0 last-paragraph-no-margin">
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Personalización de cada uno de los elementos que
                                    se puede encontrar durante el recorrido de la feria. (Recepciones y Hall de acceso).
                                </div>
                                <br><br>
                            </div>
                        </div>
                    </div>
                    <div class="icon-box d-table w-100 mx-auto mx-lg-0 last-paragraph-no-margin">
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Diseño de pabellones, distribución de stands y
                                    salas, se realiza la distribución ideal para asegurar la inmersión en los
                                    recorridos virtuales. Existen opciones definidas de stand, pero se
                                    pueden realizar a la medida. Visibilidad de sponsors. </div>
                                <br><br>
                            </div>
                        </div>
                    </div>
                    <div class="icon-box d-table w-100 mx-auto mx-lg-0 last-paragraph-no-margin">
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Configuración del contenido del stand o sala,
                                    buscamos enriquecer la experiencia de visita a cada Stand, incorporando
                                    contenido interactivo que asegure una experiencia inmersiva. </div>
                                <br><br>
                            </div>
                        </div>
                    </div>
                    <div class="icon-box d-table w-100 mx-auto mx-lg-0 last-paragraph-no-margin">
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Definición de avatares, de acuerdo al contexto
                                    corporativo, de puede diseñar según edad, aspectos físicos, cultura, medio. </div>
                                <br><br>
                            </div>
                        </div>
                    </div>
                    <div class="icon-box d-table w-100 mx-auto mx-lg-0 last-paragraph-no-margin">
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Diseño de la estrategia de recompensas. </div>
                                <br><br>
                            </div>
                        </div>
                    </div>
                    <div class="icon-box d-table w-100 mx-auto mx-lg-0 last-paragraph-no-margin">
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Integración con plataformas corporativas. </div>
                                <br><br>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-lg-4 padding-ten-right lg-padding-five-right md-padding-15px-right md-margin-five-bottom wow fadeIn border-right border-color-extra-medium-gray text-align-center"
                    style="visibility: visible; animation-name: fadeIn;">
                    <p class="subtitle-caracteristica">Durante el evento</p>
                    <div class="line-our-world2"></div> <br>
                    <div class="icon-box d-table w-100 mx-auto mx-lg-0 last-paragraph-no-margin">
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Configuración de la ventana de acceso a los
                                    participantes. </div>
                                <br>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Registro de asistencias. </div>
                                <br><br>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Activación de pabellones o salas, gestión
                                    documental. </div>
                                <br>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Personalización de Avatar. </div>
                                <br><br>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Aplicación procesos recolección de Data
                                    (mensajería entre participantes). </div>
                                <br>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Desarrollo videoconferencias. </div>
                                <br><br>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Activación tienda virtual/carrito de compras.
                                </div>
                                <br><br>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Aplicación sistemas de interacción. </div>
                                <br>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-lg-4 padding-ten-left lg-padding-five-left md-padding-15px-left md-margin-five-bottom wow fadeIn"
                    style="visibility: visible; animation-name: fadeIn;">
                    <p class="subtitle-caracteristica">Después del evento</p>
                    <div class="line-our-world2"></div> <br>
                    <div class="icon-box d-table w-100 mx-auto mx-lg-0 last-paragraph-no-margin">
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas"><b> Entrega de la Data (Estadísticas): </b>se
                                    entregan reportes para conocer el tráfico en cada uno de los eventos, los stands
                                    y la feria en general. Se identifica quién y cuándo visitó cada sección del evento.
                                </div>
                                <br>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas"><b> Citas post eventos: </b>Toda la información
                                    recolectada del evento se alojará en un repositorio para facilitar la ejecución
                                    de la siguiente versión. </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Fin caracteristicas -->

    <!-- Beneficios -->
    <div class="our-worlds-container">
        <div class="side-right-ferias">
            <p class="title-side-right-ferias">BENEFICIOS</p>
            <p class="description-side-right-ferias">
                <b>¡Somos la solución integral para el diseño y desarrollo exitoso de su feria de negocios!</b>
            </p>
            <div class="row">
                <div class="col-12 col-lg-4 col-md-6 text-center"
                    style="visibility: visible; animation-name: fadeInUp;">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Participación de audiencias globales sin necesidad de viajes ni
                        desplazamientos.</div>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center" data-wow-delay="0.2s"
                    style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Reducción en costos de logística y desarrollo del evento. </div>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Realización de eventos, sin verse afectado por restricciones de
                        confinamiento. </div><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Facilidad para contar con diferentes expositores de todo el mundo.
                    </div><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Acceso desde cualquier computador , tanto de expositores como de
                        asistentes. </div>

                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Motiva la participación de la audiencia por la asignación de
                        recompensas, durante las interacciones en el evento. </div><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->

                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Interacción entre los visitantes y expositores por medio de chats
                        y mensajes. </div>
                </div>

                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Recolección de data (estadísticas) en tiempo real, sobre las
                        interacciones y los recorridos en el evento. </div>
                </div>

                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Desarrollo de encuentros que generan un cero impacto ambiental.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Fin beneficios -->

    <!-- Funcionalidades -->
    <div class="our-worlds-container">
        <div class="side-right-ferias">
            <p class="title-side-right-ferias">Funcionalidades</p>
            <br>
            <div class="row">
                <div class="col-12 col-lg-4 col-md-6 text-center"
                    style="visibility: visible; animation-name: fadeInUp;">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Configuración de la feria en temas de duración, finalidad y los
                        participantes que desean invitar al evento, con la empresa organizadora.</div>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center" data-wow-delay="0.2s"
                    style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Definición de la programación de los diferentes eventos que van a
                        desarrollarse de forma paralela durante la feria, sesiones informativas, comerciales, etc..
                    </div>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Configuración de la agenda virtual para registrar todas y cada una
                        de las sesiones. </div><br><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Personalización de todas salas, pabellones, entre otros.
                    </div><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Configuración de la agenda para citas individuales. </div>

                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Envío de la invitaciones sus agendas y de este modo sea todo un
                        éxito de participación. </div><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->

                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Seguimiento de la participación de la feria online, en tiempo real
                        se puede conocer qué recorrido ha realizado el usuario durante el evento, donde ha permanecido
                        más tiempo o donde ha pasado de largo. </div>
                </div>

                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Configuración de todas las interacciones del usuario con el
                        recorrido de la Feria, para obtener información relevante y posteriormente realizar acciones de
                        marketing. </div>
                </div>

                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Definición de Chat, soporte y recursos que involucren la mejora de
                        experiencia de la audiencia. </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Fin funcionalidades -->
</div>
<app-footer></app-footer>